// frontend/app/utils/downloadJsonFile.js
//
// Save text as a .json file through a temporary <a download>. Web only: it
// needs the DOM, so callers gate on Platform.OS === "web".

export const saveJsonFile = (text, fileName) => {
  const blob = new Blob([text], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  try {
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.click();
  } finally {
    URL.revokeObjectURL(url);
  }
};
